import { render, staticRenderFns } from "./BatchesOptions.vue?vue&type=template&id=e0793fd0&"
import script from "./BatchesOptions.vue?vue&type=script&lang=js&"
export * from "./BatchesOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0793fd0')) {
      api.createRecord('e0793fd0', component.options)
    } else {
      api.reload('e0793fd0', component.options)
    }
    module.hot.accept("./BatchesOptions.vue?vue&type=template&id=e0793fd0&", function () {
      api.rerender('e0793fd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/BatchesOptions.vue"
export default component.exports